import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <>
      <div class="loader">
        Loading
        <span></span>
      </div>
    </>
  );
};

export default Loader;
